export default __webpack_public_path__ + "static/media/rain-4-day.4ad36472.svg";